module.exports = __webpack_public_path__ + "img/payu.05d2312b.png";